module.exports = __webpack_public_path__ + "twitter-9e91f57a.png";